import axios from 'axios';

const makeRequest = async (method, url, data, headers = {}) => {
    try {
        return await axios({
            url,
            data,
            method,
            headers: headers || {
                'Content-Type': 'application/json',
            },
        });
    } catch (error) {
        throw error.response;
    }
};

/**
 * Provide Request for API
 * */
export const get = (url, headers) => makeRequest('get', url, null, headers);
export const post = (url, data, headers) => makeRequest('post', url, data, headers);
export const put = (url, data, headers) => makeRequest('put', url, data, headers);
export const remove = (url, data, headers) => makeRequest('delete', url, data, headers);
export const patch = (url, data, headers) => makeRequest('patch', url, data, headers);